import React, { memo, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/SettingsRounded';
import { NavLink } from 'react-router-dom';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useStore from 'hooks/useStore';
import useSessions from 'hooks/useSessions';
import useCustomSelector from 'hooks/useCustomSelector';
import { sessionsSelectors } from 'features/sessions';
import { profileSelectors } from 'features/profile';

const AccountMenu = () => {
  const { clearStore } = useStore();
  const { deleteActiveSession } = useSessions();
  const { first_name, last_name } = useCustomSelector(profileSelectors.getProfileData);
  const fetching = useCustomSelector(sessionsSelectors.isFetching);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogOut = () => {
    deleteActiveSession()
    .then(({ error }) => {
      if (!error) clearStore()
    })
  };

  return (
    <>
      <IconButton
        edge='end'
        color='primary' 
        size='medium'
        aria-label='menu' 
        disabled={fetching}
        onClick={handleProfileMenuOpen}
      >
        <SettingsIcon />
      </IconButton>
      <Popover
        id='manager menu'
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        slotProps={{ paper: { sx: { width: 200, maxWidth: 200 } } }}
      > 
        {(first_name && last_name) && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 200, maxWidth: 200, height: 44 }}>
          <Typography 
            textAlign='center' 
            sx={{ color: (theme) => theme.palette.primary.main, fontWeight: 600, pointerEvents: 'none' }} 
            noWrap
          >
            {`${first_name} ${last_name}`}
          </Typography>
        </Box>}
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/settings' onClick={() => setAnchorEl(null)}>Settings</Button>
        <Button sx={{ minHeight: 44 }} fullWidth onClick={handleLogOut} disabled={fetching}>Log Out</Button>
      </Popover>
    </>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <AccountMenu {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);